<template>
    <v-container class="pt-0" fluid >
        <v-card class="px-5 py-3 br-15 w-100" elevation="0" style="border-top-left-radius: 0 !important">
            <v-row>
                <v-col>
                    <v-toolbar-title class="page-title">Acordos Comerciais</v-toolbar-title>                
                </v-col>
                <v-col cols="2">
                    <v-tooltip top :disabled="!travaInventario">
                        <template v-slot:activator="{ on }">
                            <div     v-on="on">
                            <v-btn 
                            class="new-button w-100" 
                            color="primary" 
                            @click="$refs.formulario.novo(usuarioTipo)"
                            :disabled="travaInventario" 
                        
                            v-if="['rd', 'cubo'].includes(usuarioTipo)">
                                <v-icon left>mdi-plus-thick</v-icon> Criar acordo
                            </v-btn>
                        </div>
                        </template>
                        <span>Criação de acordo desabilitada até a finalização da aprovação do inventário.</span>
                        </v-tooltip>
                </v-col>
                <v-col cols="2">
                    <v-btn class="new-button w-100" color="primary" @click="$refs.guiapdf.guiaPDF()">
                        <v-icon left>mdi-file-pdf-box</v-icon> Guia PDF
                    </v-btn>
                </v-col>
             
                <!-- <v-col cols="2">
                    <v-btn class="new-button w-100" color="primary" @click="exportar()">
                        <v-icon left>mdi-microsoft-excel</v-icon> Exportar
                    </v-btn>
                </v-col> -->
                <v-col cols="2">
                    <v-menu offset-y>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                color="primary"
                                class="new-button w-100"
                                dark
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon left>mdi-microsoft-excel</v-icon>
                                Exportar
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="exportar()">
                                <v-list-item-title
                                    >Exportação Acordos</v-list-item-title
                                >
                            </v-list-item>
                            <v-list-item @click="exportarPorLoja()">
                                <v-list-item-title>Exportação Por Loja</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportarCubo()">
                                <v-list-item-title>Exportar produto cubo</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportarPdvEcommercecampanha()">
                                <v-list-item-title>Exportar PDV/Ecommerce/Campanha</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="exportarPdvEcommercecampanha(true)">
                                <v-list-item-title>Exportação acordos consolidada</v-list-item-title>
                            </v-list-item>
                            <v-list-item v-if="usuarioTipo != 'fornecedor'" @click="exportarOportunindadesTelas()">
                                <v-list-item-title>Exportação oportunidades telas</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>

                    <!-- <v-btn class="new-button w-100" color="primary" @click="exportarPorLoja()">
                        <v-icon left>mdi-microsoft-excel</v-icon> Exportar por loja
                    </v-btn> -->
                </v-col>
            </v-row>
            <filtro ref="filtro" @filtrar="filtrar" @limpar="limpar"></filtro>
        </v-card>
        <indicadores v-if="usuarioTipo == 'rd'" ref="indicadores" :indicadores="indicadores" :filtro="$refs.filtro">
        </indicadores>
        <v-card elevation="0" class="br-15 pa-5 involucroAcordo">
            <v-data-table
                v-model="acordoSelecionado"
                :headers="headers"
                :items="acordos"
                :server-items-length="totalAcordos"
                item-key="id_acordo"
                show-select
                fixed-header
                multi-sort
                :items-per-page="5"
                :footer-props="{
                    'items-per-page-options': [5, 10, 15, 25, 50, 100, 500, -1],
                    itemsPerPageText: 'Linhas por páginas',
                    ofText: 'de',
                    pageText: '{0}-{1} de {2}',
                }" :options.sync="pagination" class="tabela paginacao-esquerda flex-table">
                <template v-slot:[`item.data-table-select`]="{
                    item,
                    isSelected,
                    select,
                }">
                    <v-simple-checkbox :ripple="false" :value="isSelected" :disabled="(!fnLiberar &&
                        !statusAcesso(
                            item.id_status,
                            'aprovar_reprovar'
                        )) ||
                        (fnLiberar &&
                            (!statusAcesso(item.id_status, 'liberar') ||
                                item.mes_acordo != mesAtual))
                        " :on-icon="(!fnLiberar &&
        !statusAcesso(
            item.id_status,
            'aprovar_reprovar'
        )) ||
        (fnLiberar &&
            (!statusAcesso(item.id_status, 'liberar') ||
                item.mes_acordo != mesAtual))
        ? 'mdi-checkbox-blank-outline'
        : 'mdi-checkbox-marked'
        " @input="select($event)"></v-simple-checkbox>
                </template>
                <template v-slot:[`item.actions`]="{ item }">
                    <v-menu offset-y min-width="180" content-class=" acordo-menu">
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn dark color="#f2f2f2" v-bind="attrs" v-on="on" small class="px-1"
                                style="min-width: unset">
                                <v-icon color="#CCC">mdi-menu</v-icon>
                            </v-btn>
                        </template>
                        <v-card>
                            <v-list dense nav>
                                <v-list-item v-if="!travaInventario && (statusAcesso(
                                    item.id_status,
                                    'aprovar_reprovar'
                                ) &&
                                    fnAprovar &&
                                    usuarioTipo == 'rd')
                                    " link @click="$refs.dialogo.reprovar(item)">
                                    <v-list-item-icon>
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Reprovar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!travaInventario && (statusAcesso(
                                    item.id_status,
                                    'aprovar_reprovar'
                                ) &&
                                    fnAprovar &&
                                    usuarioTipo == 'rd')
                                    " link @click="$refs.dialogo.aprovar(item)">
                                    <v-list-item-icon>
                                        <v-icon color="success">mdi-check</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Aprovar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!travaInventario && ( item.mes_acordo >= mesAtual &&
                                    statusAcesso(
                                        item.id_status,
                                        'editar'
                                    ) &&
                                    (['rd', 'cubo'].includes(usuarioTipo) || isUsuarioMarcasProprias()) &&
                                    !apenasLeitura(item.id_espaco))
                                    && !item.possui_acordo_negociacao_comercial
                                    " link @click="$refs.formulario.editar(item)">
                                    <v-list-item-icon>
                                        <v-icon                                                                                   color="primary">mdi-pencil</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Editar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item 
                                v-if="!travaInventario && (item.mes_acordo >= mesAtual &&
                                    statusAcesso(
                                        item.id_status,
                                        'replicar_bandeira'
                                    ) &&
                                    ['rd', 'cubo'].includes(usuarioTipo) &&
                                    !apenasLeitura(item.id_espaco)
                                    )" 
                                    link 
                                    @click="
                                        $refs.formulario.replicarAcordo(
                                            item,
                                            'bandeira'
                                        )
                                        ">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-autorenew</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>Replicar
                                            Bandeira</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="item.mes_acordo >= mesAtual &&
                                    statusAcesso(
                                        item.id_status,
                                        'replicar_checkout'
                                    ) &&
                                    item.espaco_macro == 'Check-out'
                                    &&
                                    usuarioTipo == 'rd' &&
                                    !apenasLeitura(item.id_espaco)
                                    " link @click="
                                        $refs.formulario.replicarAcordo(
                                            item,
                                            'checkout'
                                        )
                                        ">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-autorenew</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>Replicar
                                            Tipo Check-out</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="item.mes_acordo >= mesAtual &&
                                    statusAcesso(
                                        item.id_status,
                                        'replicar_bandeira'
                                    ) &&
                                    item.espaco_macro == 'Tela'
                                    &&
                                    usuarioTipo == 'rd' &&
                                    !apenasLeitura(item.id_espaco)
                                    " link @click="
                                        $refs.formulario.replicarAcordo(
                                            item,
                                            'tela'
                                        )
                                        ">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-autorenew</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>Replicar
                                            Tela</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!travaInventario && (item.mes_acordo >= mesAtual &&
                                    statusAcesso(
                                        item.id_status,
                                        'replicar_cancelado'
                                    ) &&
                                    usuarioTipo == 'rd' &&
                                    !apenasLeitura(item.id_espaco))
                                    " link @click="
                                        $refs.formulario.replicarAcordo(
                                            item,
                                            'cancelado'
                                        )
                                        ">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-autorenew</v-icon>
                                    </v-list-item-icon>

                                    <v-list-item-content>
                                        <v-list-item-title>Replicar
                                            Cancelado</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item link @click="$refs.dialogo.historico(item)" v-if="['rd', 'cubo'].includes(usuarioTipo)">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-file-document-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Histórico</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item link @click="$refs.formulario.editar(item, true)">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-file-document-edit</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Exibir Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!travaInventario && (item.termino == item.mes_acordo &&
                                    item.termino >= mesAnterior &&
                                    statusAcesso(
                                        item.id_status,
                                        'renovar'
                                    ) &&
                                    ['rd', 'cubo'].includes(usuarioTipo) &&
                                    !apenasLeitura(item.id_espaco))
                                    " link @click="$refs.dialogo.renovacao(item)">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-update</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Renovar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="(item.planograma || item.planograma_cluster) && (!['Cubo'].includes(item.espaco_macro) || !planogramaAutomaticoMD(item.id_espaco))" link @click="$refs.dialogo.planograma(item)">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-image</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Planograma</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!travaInventario && (statusAcesso(
                                    item.id_status,
                                    'editar_planograma'
                                ) && (['rd', 'cubo'].includes(usuarioTipo) || isUsuarioMarcasProprias()))
                                && !['Cubo'].includes(item.espaco_macro)  && !planogramaAutomaticoMD(item.id_espaco)
                                && !apenasLeitura(item.id_espaco)
                                    " link @click="
                                    editarPlanograma(item)
        
                                    ">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-image-edit</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Editar
                                            Planograma</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="item.obs_departamento &&
                                    usuarioTipo == 'rd'
                                    " link @click="
        $refs.dialogo.dialogDepartamento(item)
        ">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-clipboard-text-outline</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Obs.
                                            Departamento</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="item.obs_contrato && usuarioTipo == 'rd'
                                    " link @click="$refs.dialogo.dialogContrato(item)">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-clipboard-text</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Obs. Contrato</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item v-if="!travaInventario && (statusAcesso(
                                    item.id_status,
                                    'cancelar'
                                ) && ['rd', 'cubo'].includes(usuarioTipo) &&
                                !apenasLeitura(item.id_espaco))
                                && !item.possui_acordo_negociacao_comercial
                                    " link @click="$refs.dialogo.cancelar(item)">
                                    <v-list-item-icon>
                                        <v-icon color="error">mdi-close</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Cancelar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <v-list-item
                                    v-if="
                                      !travaInventario && (  fnLiberar &&
                                        statusAcesso(
                                            item.id_status,
                                            'liberar'
                                        ) &&
                                        item.mes_acordo == mesAtual &&
                                        usuarioTipo == 'rd' &&
                                        !apenasLeitura(item.id_espaco))
                                    "
                                    link
                                    @click="$refs.dialogo.liberar([item.id_acordo],parseFloat(item.investimento.replace('R$ ','').replace('.','').replace(',','.')))"
                                >
                                    <v-list-item-icon>
                                        <v-icon color="success">mdi-check</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Liberar Acordo</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                                <!-- Relançar acordo cancelado API-->

                                <v-list-item v-if="item.cancelado_api == true && usuarioTipo == 'rd'" link @click="$refs.dialogo.relancar(item)">
                                    <v-list-item-icon>
                                        <v-icon color="primary">mdi-autorenew</v-icon>
                                    </v-list-item-icon>
                                    <v-list-item-content>
                                        <v-list-item-title>Relançar Acordo Cancelado</v-list-item-title>
                                    </v-list-item-content>
                                </v-list-item>
                            </v-list>
                        </v-card>
                    </v-menu>
                </template>
            </v-data-table>

            <div 
            
            class="
                    table-footer-prepend
                    d-flex
                    pl-2
                    pt-4
                    align-center
                    justify-end
                ">
                <v-btn v-if="!fnLiberar" class="new-button ml-5" :disabled="travaInventario  || (!acordoSelecionado.filter((e) =>
                    statusAcesso(e.id_status, 'aprovar_reprovar')
                ).length || !fnAprovar)
                    " color="primary" @click="$refs.dialogo.aprovar(acordoSelecionado)">
                    <v-icon left>mdi-check-circle</v-icon> Aprovar Acordos
                </v-btn>
                <v-btn v-if="!fnLiberar" class="new-button ml-5" :disabled="travaInventario  || (!acordoSelecionado.filter((e) =>
                    statusAcesso(e.id_status, 'aprovar_reprovar')
                ).length || !fnAprovar)
                    " color="error" @click="$refs.dialogo.reprovar()">
                    <v-icon left>mdi-close-circle</v-icon> Reprovar acordos
                </v-btn>
                <v-btn
                    v-if="fnLiberar"
                    class="new-button ml-5"
                    :disabled="
                        !acordoSelecionado.filter(
                            (e) =>
                                statusAcesso(e.id_status, 'liberar') &&
                                e.mes_acordo == mesAtual  &&
                                        usuarioTipo == 'rd'
                        ).length
                    "
                    color="primary"
                    @click="dialogoLiberarAcordos()"
                >
                    <v-icon left>mdi-check</v-icon> Liberar acordos
                </v-btn>
            </div>

            <dialogo
                ref="dialogo"
                @aprovarAcordo="aprovarAcordo" 
                @liberarAcordo="liberarAcordo"
                @filtrar="filtrar"
                @renovar="renovar"
                @relancar="relancar"
            ></dialogo>

            <formulario ref="formulario" @filtrar="filtrar"></formulario>

            <v-overlay :value="carregando">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>

            <v-snackbar v-model="alerta" :color="alertaColor" :timeout="alertaTimeout" top style="z-index: 400">
                <v-alert :type="alertaColor">
                    {{ alertaTexto }}
                </v-alert>
                <v-btn dark text class="float-right" @click="alerta = false">
                    Fechar
                </v-btn>
            </v-snackbar>

            <guiapdf ref="guiapdf"></guiapdf>
        </v-card>

        <v-snackbar
            v-model="alerta"
            :color="alertaColor"
            :timeout="alertaTimeout"
            top
            style="z-index: 400"
        >
            <v-alert :type="alertaColor">
                {{ alertaTexto }}
            </v-alert>
            <v-btn dark text class="float-right" @click="alerta = false">
                Fechar
            </v-btn>
        </v-snackbar>
    </v-container>
</template>

<script>
import Filtro from "./Filtro.vue";
import Dialogo from "./Dialogo.vue";
import Indicadores from "./Indicadores.vue";
import Formulario from "./formulario/Formulario.vue";
import Guiapdf from "./GuiaPDF.vue";
import useFiltros from "../../hooks/useFiltros";
import useTravaInventario from "../../hooks/useTravaInventario";
import useUsuario from "../../hooks/useUsuario";

export default {
    setup() {
        const { isLoading, isError, isFetching, lista, error, refetch } =
            useFiltros("/acordo/listaCampos");

        const { estadoInventario, iniciarMonitoramentoInventario, interromperMonitoramento } = useTravaInventario();
        const { isUsuarioMarcasProprias } = useUsuario();
        iniciarMonitoramentoInventario();
        return {
            isLoading,
            isError,
            isFetching,
            lista,
            error,
            refetch,
            isUsuarioMarcasProprias,

            // props do useTravaInventario
            estadoInventario,
            iniciarMonitoramentoInventario,
            interromperMonitoramento
        };
    },
    components: {
        Filtro,
        Dialogo,
        Indicadores,
        Formulario,
        Guiapdf,
    },
    data() {
        return {
            headers: [
                {
                    text: "Menu",
                    value: "actions",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Acordo",
                    value: "id_acordo",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Acordo RD",
                    value: "acordo_rd",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Lote",
                    value: "id_lote",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Fornecedor",
                    value: "fornecedor",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Espaço",
                    value: "espaco",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Espaço Macro",
                    value: "espaco_macro",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Bandeira",
                    value: "bandeira",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Mês",
                    value: "mes",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Ano",
                    value: "ano",
                    align: "center",
                    class: "th-separador   ",
                },
                // {
                //     text: "Oportunidade",
                //     value: "oportunidade",
                //     sortable: false,
                //     align: "center",
                //     class: "th-separador   ",
                // },
                {
                    text: "Contrato",
                    value: "id_contrato",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Contrato RD",
                    value: "contrato",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Parcela",
                    value: "parcela",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },

                {
                    text: "Acor. Teste",
                    value: "flag_teste",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Status",
                    value: "status",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Just. Desconto",
                    value: "justificativa",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Just. Reprov.",
                    value: "justificativa_reprovacao",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Just. Cancel.",
                    value: "justificativa_cancelamento",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Produtos",
                    value: "produtos",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Prod. Edit.",
                    value: "produtos_alterados",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "VB",
                    value: "vb",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Filiais",
                    value: "filiais",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Filiais Edit.",
                    value: "filiais_alteradas",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Visivel",
                    value: "visivel",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Valor s/ Desc.",
                    value: "valor",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "% Padrão",
                    value: "desconto_padrao",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "% Fora",
                    value: "desconto_percentual",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Desconto",
                    value: "desconto",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Total Desc.",
                    value: "desconto_total",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Invest.",
                    value: "investimento",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Invest.Hist.",
                    value: "investimento_historico",
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Cluster Acordo",
                    value: "cluster_acordo_nome",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Cluster Filiais",
                    value: "cluster",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Modelo Check-out Acordo",
                    value: "check_out_modelo",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Modelo Check-out Filiais",
                    value: "check_out_organico",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {    
                    text: "Região",
                    value: "regiao",
                    sortable: false,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Usuário que Criou",
                    value: "usuario_criacao",
                    sortable: true,
                    align: "center",
                    class: "th-separador   ",
                },
                {
                    text: "Cód. Fornecedor",
                    value: "codigo",
                    align: "center",
                    class: "th-separador   ",
                },                
                {
                    text: "Negociação Comercial",
                    value: "negociacao_comercial",
                    align: "center",
                    class: "th-separador   ",
                },                
            ],
            acordos: [],
            indicadores: {},
            planograma: [],
            statusIndicadores: [],
            totalAcordos: 0,
            pagination: {},
            carregando: false,
            acordoSelecionado: [],
            justificativas: [],
            status: [],
            alerta: false,
            alertaTexto: "",
            alertaColor: "error",
            alertaTimeout: 3000,
            fnAprovar: false,
            fnLiberar: false,
        };
    },
    provide() {
        return {
            listaCampos: this.listaCampos(),
            usuarioTipo: this.usuarioTipo,
        };
    },
    watch: {
        pagination: {
            handler() {
                this.filtrar(false);
            },
            deep: true,
        },
        estadoInventario: {
            handler() {
                if (this.estadoInventario.msgModalInventario !== ''){
                    this.alerta = true
                    this.alertaColor = 'success'
                    this.alertaTimeout = -1
                    this.alertaTexto = this.estadoInventario.msgModalInventario;
                }
            },
            deep: true,
        },
    },
    async beforeCreate() {
        var response = await this.$http().post("/acordo/status", {});

        this.status = response.data;

        response = await this.$http().post("/acordo/permissao", { id_menu: 2 });

        this.fnAprovar = response.data;
    },
    beforeDestroy() {
        this.interromperMonitoramento();
    },
    computed: {
        mesAtual() {
            return this.$moment().format("YYYY-MM");
        },
        mesAnterior() {
            return this.$moment().subtract(1, "months").format("YYYY-MM");
        },
        mesProximo() {
            return this.$moment().add(1, "months").format("YYYY-MM");
        },
        travaInventario() {
            return this.estadoInventario.inventarioTravado
        },
        usuarioTipo() {
            const usuario = this.$store.getters.getUsuario;
            if (usuario.id_fornecedor) {
                return "fornecedor";
            }
            if(usuario.cargo == "Cubo"){
                return "cubo";
            }
            return "rd";
        },


    },
    methods: {
        async listaCampos() {
            var response = await this.$http().post("/acordo/listaCampos", {});

            return response.data;
        },
        async editarPlanograma(item) {
            await this.$refs.dialogo.planogramaEditar(item)
        },
        limpar() {
            this.planograma = [];
            this.statusIndicadores = [];
            // this.fnLiberar = false;

            this.filtrar();
        },
        async filtrar(paginaInicial = true) {
            if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            this.acordoSelecionado = [];

            var filtro = this.$refs.filtro.filtro;

            var data = {};

            data.mesInicial = filtro.mesInicial
                ? filtro.mesInicial
                : this.$moment().format("YYYY-MM");
            data.mesFinal = filtro.mesFinal
                ? filtro.mesFinal
                : this.$moment().format("YYYY-MM");
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1;

            data.bandeira = filtro.bandeira;
            data.id_espaco = filtro.id_espaco;
            data.espaco_macro = filtro.espaco_macro;
            data.id_fornecedor = filtro.id_fornecedor;
            data.id_status = filtro.id_status ? filtro.id_status : [];
            data.id_acordo = filtro.id_acordo ? [filtro.id_acordo] : [];
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : [];
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : [];
            data.id_cluster = filtro.id_cluster ? filtro.id_cluster : [];
            data.id_usuario = filtro.id_usuario ? filtro.id_usuario : [];
            data.contrato = filtro.contrato ? [filtro.contrato] : [];
            data.regiao = filtro.regiao ? filtro.regiao : []
            data.id_lote = filtro.id_lote ? [filtro.id_lote] : []
            data.visivel = filtro.visivel ? [filtro.visivel] : [];
            data.planograma = filtro.planograma;
            data.statusIndicadores = this.statusIndicadores;
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];

            if (paginaInicial) this.pagination.page = 1;

            data.pagination = this.pagination;

            var response = await this.$http().post("/acordo/lista", {
                data: data,
            });
            // console.log('paaoun aqui')
            this.acordos = response.data.lista //.map(item => {
            //     return {...item,espaco:item.prateleira_nome ? item.prateleira_nome : item.espaco}
            // });
            this.totalAcordos = response.data.total;
            // this.$refs.indicadores.setIndicadores(response.data.indicadores);
            // if (this.usuarioTipo == "rd") {
            //     this.$refs.indicadores.setIndicadores(
            //         response.data.indicadores
            //     );
            // }
            this.indicadores = response.data.indicadores;

            if (this.acordos.length == 0 && this.pagination.page > 1) {
                this.filtrar();
            }
            this.fnLiberar = ((data.id_status[0] == 29) && (([1,2].includes(this.$store.getters.getUsuario.id_cargo)))) ? true : false;

            this.carregando = false;
        },
        async exportar() {
            if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            var filtro = this.$refs.filtro.filtro;

            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesFinal;
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1;

            data.bandeira = filtro.bandeira;
            data.id_espaco = filtro.id_espaco;
            data.espaco_macro = filtro.espaco_macro;
            data.id_fornecedor = filtro.id_fornecedor;
            data.id_status = filtro.id_status ? filtro.id_status : [];
            data.id_acordo = filtro.id_acordo ? [filtro.id_acordo] : [];
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : [];
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : [];
            data.id_cluster = filtro.id_cluster ? filtro.id_cluster : [];
            data.id_usuario = filtro.id_usuario ? filtro.id_usuario : [];
            data.regiao = filtro.regiao ? filtro.regiao : []
            data.id_lote = filtro.id_lote ? [filtro.id_lote] : []
            data.contrato = filtro.contrato ? [filtro.contrato] : [];
            data.visivel = filtro.visivel ? [filtro.visivel] : [];
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];
            data.planograma = this.planograma;
            data.statusIndicadores = this.statusIndicadores;

            var response = await this.$http().post("/acordo/exportar", {
                data: data,
            });

            window.location = this.$http("baseURL") + response.data.url;

            this.carregando = false;
        },
        async exportarPorLoja() {
            if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            var filtro = this.$refs.filtro.filtro;

            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesFinal;
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1;

            data.bandeira = filtro.bandeira;
            data.id_espaco = filtro.id_espaco;
            data.espaco_macro = filtro.espaco_macro;
            data.id_fornecedor = filtro.id_fornecedor;
            data.id_status = filtro.id_status ? filtro.id_status : [];
            data.id_acordo = filtro.id_acordo ? [filtro.id_acordo] : [];
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : [];
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : [];
            data.id_cluster = filtro.id_cluster ? filtro.id_cluster : [];
            data.id_usuario = filtro.id_usuario ? filtro.id_usuario : [];
            data.contrato = filtro.contrato ? [filtro.contrato] : [];
            data.visivel = filtro.visivel ? [filtro.visivel] : [];
            data.planograma = this.planograma;
            data.statusIndicadores = this.statusIndicadores;
            data.id_lote = filtro.id_lote ? [filtro.id_lote] : []
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];


            var response = await this.$http().post("/acordo/exportarporloja", {
                data: data,
            });

            window.location = this.$http("baseURL") + response.data.url;

            this.carregando = false;
        },
        async exportarCubo() {
            if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            var filtro = this.$refs.filtro.filtro;

            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesFinal;
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1;

            data.bandeira = filtro.bandeira;
            data.id_espaco = filtro.id_espaco;
            data.espaco_macro = filtro.espaco_macro;
            data.id_fornecedor = filtro.id_fornecedor;
            data.id_status = filtro.id_status ? filtro.id_status : [];
            data.id_acordo = filtro.id_acordo ? [filtro.id_acordo] : [];
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : [];
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : [];
            data.id_cluster = filtro.id_cluster ? filtro.id_cluster : [];
            data.id_usuario = filtro.id_usuario ? filtro.id_usuario : [];
            data.contrato = filtro.contrato ? [filtro.contrato] : [];
            data.visivel = filtro.visivel ? [filtro.visivel] : [];
            data.planograma = this.planograma;
            data.statusIndicadores = this.statusIndicadores;
            data.id_lote = filtro.id_lote ? [filtro.id_lote] : []
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];


            var response = await this.$http().post("/acordo/exportarcubo", {
                data: data,
            });

            window.location = this.$http("baseURL") + response.data.url;

            this.carregando = false;
        },
        async exportarPdvEcommercecampanha(csv = false) {
            if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            var filtro = this.$refs.filtro.filtro;

            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesFinal;
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1;

            data.bandeira = filtro.bandeira;
            data.id_espaco = filtro.id_espaco;
            data.espaco_macro = filtro.espaco_macro;
            data.id_fornecedor = filtro.id_fornecedor;
            data.id_status = filtro.id_status ? filtro.id_status : [];
            data.id_acordo = filtro.id_acordo ? [filtro.id_acordo] : [];
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : [];
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : [];
            data.id_cluster = filtro.id_cluster ? filtro.id_cluster : [];
            data.id_usuario = filtro.id_usuario ? filtro.id_usuario : [];
            data.regiao = filtro.regiao ? filtro.regiao : []
            data.id_lote = filtro.id_lote ? [filtro.id_lote] : []
            data.contrato = filtro.contrato ? [filtro.contrato] : [];
            data.visivel = filtro.visivel ? [filtro.visivel] : [];
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];
            data.planograma = this.planograma;
            data.statusIndicadores = this.statusIndicadores;

            var response = await this.$http().post(
                "/acordo/exportarPdvEcommerceCampanha" + (csv ? "CSV" : ""), 
                {
                    data: data,
                }
            );

            window.location = this.$http("baseURL") + response.data;


            // window.location = this.$http("baseURL") + response.data.url;
            if (response.status !== 200) {
                this.mensagemProcessamento =
                    "Erro ao gerar o arquivo. Tente novamente.";
                this.porcentagem = 100;
                this.erroProcessamento = true;
            }
            this.carregando = false;
        },
        async exportarOportunindadesTelas() {
            if (!this.$refs.filtro.validate()) return;

            this.carregando = true;

            var filtro = this.$refs.filtro.filtro;

            var data = {};

            data.mesInicial = filtro.mesInicial;
            data.mesFinal = filtro.mesFinal;
            data.tipoPeriodo = filtro.tipoPeriodo ? filtro.tipoPeriodo : -1;

            data.bandeira = filtro.bandeira;
            data.id_espaco = filtro.id_espaco;
            data.espaco_macro = filtro.espaco_macro;
            data.id_fornecedor = filtro.id_fornecedor;
            data.id_status = filtro.id_status ? filtro.id_status : [];
            data.id_acordo = filtro.id_acordo ? [filtro.id_acordo] : [];
            data.acordo_rd = filtro.acordo_rd ? [filtro.acordo_rd] : [];
            data.id_contrato = filtro.id_contrato ? [filtro.id_contrato] : [];
            data.id_cluster = filtro.id_cluster ? filtro.id_cluster : [];
            data.id_usuario = filtro.id_usuario ? filtro.id_usuario : [];
            data.regiao = filtro.regiao ? filtro.regiao : []
            data.id_lote = filtro.id_lote ? [filtro.id_lote] : []
            data.contrato = filtro.contrato ? [filtro.contrato] : [];
            data.visivel = filtro.visivel ? [filtro.visivel] : [];
            data.id_macrofornecedor = filtro.id_macrofornecedor ? filtro.id_macrofornecedor : [];
            data.planograma = this.planograma;
            data.statusIndicadores = this.statusIndicadores;

            var response = await this.$http().post(
                "/acordo/exportarOportunidadeTelas", 
                {
                    data: data,
                }
            );

            window.location = this.$http("baseURL") + response.data.url;


            // window.location = this.$http("baseURL") + response.data.url;
            if (response.status !== 200) {
                this.mensagemProcessamento =
                    "Erro ao gerar o arquivo. Tente novamente.";
                this.porcentagem = 100;
                this.erroProcessamento = true;
            }
            this.carregando = false;
        },
        async aprovarAcordo(data) {
            this.carregando = true;

            data.acordos = data.id_acordo
                ? [data.id_acordo]
                : this.acordoSelecionado
                    .filter((e) =>
                        this.statusAcesso(e.id_status, "aprovar_reprovar")
                    )
                    .map((a) => a.id_acordo);

            var response = await this.$http().post("/acordo/aprovarAcordo", {
                data: data,
            });

            if (response.data.sucesso) {
                this.filtrar(false);
            } else {
                this.alerta = true;
                this.alertaColor = "error";
                this.alertaTimeout = -1;
                this.alertaTexto = response.data.msg;
            }

            this.acordoSelecionado = [];
            this.carregando = false;
        },
        async dialogoLiberarAcordos(acordo = null) {
            let acordos = acordo ? [acordo] : this.acordoSelecionado.filter((e) =>
                    this.statusAcesso(e.id_status, "liberar") &&
                    e.mes_acordo == this.mesAtual
            )

            const response = await this.$http().post("/acordo/acordosSemLiberacao", {
                data: {
                    acordos: acordos.map((a) => a.id_acordo),
                },
            });
            
            if (response.status == 200) {
                const acordosValidos = acordos.filter((i => !response.data.acordosSemLiberacao.includes(i.id_acordo)));
                const total = acordosValidos.reduce((a,e) => {
                    const valor = e.investimento ? parseFloat(e.investimento.replace('R$ ','').replace('.','').replace(',','.')) : 0;
                    return a + valor;
                }, 0);
                acordos = acordos.map((a) => a.id_acordo);
                this.$refs.dialogo.liberar(acordos,total)
            }
        },
        async liberarAcordo(acordos) {
            this.carregando = true;

            // data.acordos = data.id_acordo
            //     ? [data.id_acordo]
            //     : this.acordoSelecionado
            //           .filter(
            //               (e) =>
            //                   this.statusAcesso(e.id_status, "liberar") &&
            //                   e.mes_acordo == this.mesAtual
            //           )
            //           .map((a) => a.id_acordo);

            var response = await this.$http().post("/acordo/liberarAcordo", {
                data: {
                    acordos: acordos,
                },
            });

            if (response.data.sucesso) {
                if (response.data.msgSemRd && response.data.msgSemRd !== ''){
                    this.alerta = true;
                    this.alertaColor = "warning";
                    this.alertaTimeout = -1;
                    this.alertaTexto = response.data.msgSemRd;
                }
                await this.filtrar(false);
            } else {
                this.alerta = true;
                this.alertaColor = "error";
                this.alertaTimeout = -1;
                this.alertaTexto = response.data.msg;
            }

            this.acordoSelecionado = [];
            this.carregando = false;
        },
        statusAcesso(id_status, acesso) {
            if (this.status) {
                if (id_status === 30 && acesso === "editar_planograma")
                    return false;

                var status = this.status.find((e) => e.id_status == id_status);

                return status[acesso];
            } else {
                return false;
            }
        },
        renovar(data) {
            
            this.$refs.formulario.editar(data.item);
        },
        relancar(data) {
            console.log(data)
            this.$refs.formulario.editar(data);
        },
  
        planogramaAutomaticoMD (id_espaco) {
            const espacosConsideradosMD = [74,633,639,645,651,657,663, 669, 675, 681, 1375, 687, 693]
            return espacosConsideradosMD.includes(id_espaco)
        },
        apenasLeitura(id_espaco) {
            // se for acesso rd retorna false 
            if(this.usuarioTipo == "rd") return false;
            return this.lista.espacoSomenteLeitura.find((e) => e.id_espaco == id_espaco)
        }
    }
};
</script>

<style >
.theme--light.v-data-table.v-data-table--fixed-header thead th {
    background: var(--v-primary-base) !important;
    box-shadow: inset 0 -1px 0 rgb(0 0 0 / 12%);
}

.involucroAcordo {
    height: 450px;
    display: flex;
    margin-top: 20px;
    /* flex-grow: 1; */
    /* overflow: hidden; */
    display: flex;
    flex-direction: column;
}

.involucroAcordo .flex-table {
    display: flex;
    flex-direction: column;
    /* flex-grow: 1; */
    height: 420px;
    width: 100%;
}

.involucroAcordo .flex-table>div {
    width: 100%;
}

.involucroAcordo header {
    top: 0px;
    background-color: #ffff;
    z-index: 4;
}
</style>